module.exports = __webpack_public_path__ + "static/service-icon3-27d870f3b922f44d9b4668ecc19651e3.png";